var render = function () {
  var _class, _class2, _class3, _class4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isMobileDesign ? _c('div', {
    class: (_class = {}, _class[_vm.$style.appBlock] = true, _class['light-transparent'] = _vm.isTransparent, _class),
    on: {
      "mouseover": function mouseover($event) {
        _vm.isTransparent = true;
      },
      "mouseout": function mouseout($event) {
        _vm.isTransparent = false;
      },
      "click": function click($event) {
        return _vm.redirectToAppUrl(_vm.appUrl);
      }
    }
  }, [_c('div', {
    class: _vm.$style.cardImageContainer,
    style: {
      'background-image': 'url(\'' + encodeURI(_vm.cardImagePath) + '\')'
    }
  }), _c('div', {
    class: _vm.$style.appDescriptionBlock
  }, [_c('div', {
    staticClass: "tag-text",
    class: (_class2 = {}, _class2[_vm.$style.appCategoryTag] = true, _class2[_vm.$style.appCategoryTagInTheMiddle] = _vm.normalizedOptions.showDescription, _class2),
    style: {
      'background-color': _vm.appBackgroundColor
    }
  }, [_vm._v(" " + _vm._s(_vm.getCategory) + " ")]), _vm.normalizedOptions.showDescription ? _c('div', {
    class: _vm.$style.appDescription
  }, [_c('p', {
    staticClass: "button-text color-primary-blue mt-15"
  }, [_vm._v(_vm._s(_vm.name))]), _c('p', {
    staticClass: "p2 color-primary-charcoal"
  }, [_vm._v(_vm._s(_vm.description))])]) : _vm._e()]), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _vm.appId ? _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick,
      "mouseover": function mouseover($event) {
        $event.stopPropagation();
        _vm.isTransparent = false;
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isMobileDesign && !_vm.normalizedOptions.showDescription ? _c('div', {
    staticClass: "d-flex",
    class: (_class3 = {}, _class3[_vm.$style.appBlockMobile] = true, _class3['light-transparent'] = _vm.isTransparent, _class3),
    style: {
      width: "".concat(_vm.mobileCardImageDimensions.width, "px")
    },
    on: {
      "mouseover": function mouseover($event) {
        _vm.isTransparent = true;
      },
      "mouseout": function mouseout($event) {
        _vm.isTransparent = false;
      },
      "click": function click($event) {
        return _vm.redirectToAppUrl(_vm.appUrl);
      }
    }
  }, [_c('div', {
    class: _vm.$style.cardImageContainerMobile,
    style: {
      'background-image': 'url(\'' + encodeURI(_vm.cardImagePathMobile) + '\')',
      width: "".concat(_vm.mobileCardImageDimensions.width, "px"),
      height: "".concat(_vm.mobileCardImageDimensions.height, "px")
    }
  }), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _vm.normalizedOptions.showHeart ? _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick,
      "mouseover": function mouseover($event) {
        $event.stopPropagation();
        _vm.isTransparent = false;
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isMobileDesign && _vm.normalizedOptions.showDescription ? _c('div', {
    staticClass: "d-flex",
    class: (_class4 = {}, _class4[_vm.$style.appBlockMobileWithDescription] = true, _class4['light-transparent'] = _vm.isTransparent, _class4)
  }, [_c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    class: _vm.$style.cardImageContainerMobileWithDescription,
    style: {
      'background-image': 'url(\'' + encodeURI(_vm.cardImagePathMobile) + '\')'
    },
    on: {
      "click": function click($event) {
        return _vm.redirectToAppUrl(_vm.appUrl);
      }
    }
  }), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIconMobileWithDescription
  }) : _vm.appId ? _c('FavoriteHeart', {
    class: _vm.$style.heartIconMobileWithDescription,
    attrs: {
      "is-favorite": _vm.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick,
      "mouseover": function mouseover($event) {
        $event.stopPropagation();
        _vm.isTransparent = false;
      }
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('h4', {
    staticClass: "color-primary-charcoal mb-10 font-weight-bold cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.redirectToAppUrl(_vm.appUrl);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _c('div', {
    staticClass: "tag-text",
    class: _vm.$style.appCategoryTagMobileWithDescription,
    style: {
      'background-color': _vm.appBackgroundColor
    }
  }, [_vm._v(" " + _vm._s(_vm.getCategory) + " ")]), _c('p', {
    staticClass: "p1",
    on: {
      "click": function click($event) {
        return _vm.redirectToAppUrl(_vm.appUrl);
      }
    }
  }, [_vm._v(_vm._s(_vm.description))])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }